module.exports = {"app.components.NotFoundPage.header":"","app.containers.Agenda.header":"","app.containers.AgenziaKiron.header":"","app.containers.Anagrafica.header":""}


//////////////////
// WEBPACK FOOTER
// ./app/translations/en.json
// module id = ./app/translations/en.json
// module chunks = 35